// extracted by mini-css-extract-plugin
module.exports = {"name":"index-module_name_66S8A"};